import React, { useContext, useState } from 'react';
import { AuthContext } from '../../context/AuthContext';
import SideMenu from '../SideMenu';
import menuConfig from '../../config/menuConfig';
import './MainLayout.css';

const pageTitles = {
  '/dashboard': 'Dashboard',
  '/orders': 'Orders',
  '/users': 'Users',
  '/bill-to-bill': 'Bill to Bill',
  '/tenure': 'Tenure Management',
  '/wallet-topup': 'Wallet Topup',
  '/points-rules': 'Points Rules',
  '/points-analytics': 'Points Analytics',
  '/discounts': 'Category Discounts',
  '/banners': 'Banners',
  '/notifications': 'Notifications',
  '/support': 'Support',
};

const MainLayout = ({ children, currentPath, onNavigate }) => {
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(() =>
    localStorage.getItem('ks_marketplace_sidebar') === 'expanded'
  );
  const { auth } = useContext(AuthContext);
  const basePath = `/${(currentPath.split('?')[0].split('/')[1] || 'dashboard')}`;
  const pageTitle = pageTitles[basePath] || 'KeyShop Admin';
  const userName = auth?.user?.business_name || auth?.user?.full_name || auth?.user?.email || 'Admin';
  const initials = userName.trim().slice(0, 2).toUpperCase();

  const toggleSidebar = (expanded) => {
    setIsSidebarExpanded(expanded);
    localStorage.setItem('ks_marketplace_sidebar', expanded ? 'expanded' : 'collapsed');
  };

  return (
    <div className="main-layout">
      <SideMenu
        menuItems={menuConfig}
        currentPath={currentPath}
        onNavigate={onNavigate}
        isExpanded={isSidebarExpanded}
        onToggleExpand={toggleSidebar}
      />

      <div className={`main-shell ${isSidebarExpanded ? 'main-shell--expanded' : ''}`}>
        <header className="admin-topbar">
          <div>
            <p>KeyShop Marketplace</p>
            <h1>{pageTitle}</h1>
          </div>
          <div className="admin-user">
            <span className="admin-user-name">{userName}</span>
            <span className="admin-user-avatar">{initials || 'KS'}</span>
          </div>
        </header>
        <main className="main-content" role="main">{children}</main>
      </div>
    </div>
  );
};

export default MainLayout;
